<template>
    <div class="modal-mask">
        <div class="close-container">
            <i v-if="imgLoad == imgNumber" class="fas fa-times close" @click="hideLargeImage()"/>
            <!-- <i v-if="imgLoad == imgNumber" class="fas fa-times" @click="hideLargeImage()"/> -->
        </div>
        <div class="container" role="dialog">
            <div style="width: 100%; height: 100%; display: flex; align-items: center; text-align: center; justify-content: center;">
                <div class="chevron-container">
                    <i class="fas fa-chevron-left chevron" @click="calculateImage('rest')" id="inside"/>
                </div>
                <div style="height: 100%; display: grid;" v-clickOutside="hideLargeImage">
                    <img style="max-width: 100%; max-height: 90vh;" @load="imgLoad = imgNumber" :src="require('../../public/img/' + details.name + '/' + imgNumber + '.jpg')" id="inside" />
                </div>
                <div class="chevron-container">
                    <i class="fas fa-chevron-right chevron" @click="calculateImage('sum')" id="inside"/>
                </div>
            </div>
        </div>
        <div style="margin: 5px; opacity: 0.5">
            <i v-if="isLoading" class="fas fa-circle-notch fa-spin" style="color: white; text-shadow: none;"></i>
            <span v-else> {{imgNumber}} / {{details.count}} </span>
        </div>
    </div>
</template>

<script type="text/javascript">
  export default {

    directives: {
        clickOutside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    if ( event.target.id != 'inside' && event.target.id != 'square-img' ) {
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
        }
    },
    
    props: {
        details:    { type: Object, required: true },
        imgClicked: { type: Number, required: false, default: 1 },
    },

    data() {
        return {
            imgLoad: null,
            imgNumber: this.imgClicked
        }
    },

    computed: {
        isLoading(){
            return this.imgLoad != this.imgNumber ? true : false;
        }
    },
    
    beforeMount: function() {
        document.body.style.overflow = 'hidden' ;
    },

    mounted(){
        document.body.addEventListener('keyup', e => {
            if (e.keyCode === 27 || e.keyCode === 8) {
                this.hideLargeImage();
            }
            if (e.keyCode === 37) {
                this.calculateImage('rest');
            }
            if (e.keyCode === 39) {
                this.calculateImage('sum');
            }
        });
    },

    beforeDestroy: function() {
        document.body.style.overflow = '' ;
    },

    methods: {
       
       calculateImage(input) {
            if(input == 'sum'){
                if(this.imgNumber == this.details.count){
                    this.imgNumber = 1;
                }
                else {
                    this.imgNumber = this.imgNumber + 1;
                }
            }
            else {
                if(this.imgNumber == 1){
                    this.imgNumber = this.details.count;
                }
                else {
                    this.imgNumber = this.imgNumber - 1;
                }
            }
        },
        hideLargeImage(){
            this.$emit('hideImg');
        }
    }

  }
</script>

<style lang="scss" scoped>
@import "./variables.scss";
.chevron {
    opacity: .2;
    height: 30%;
    width: 100%;
    margin: 10px;
    display: flex;
    color: white;
    font-size: 40px;
    align-items: center;
    justify-content: center;
    &:hover {
        opacity: .8;
    }
    @media screen and (max-width: $break-sm) {
        font-size: 30px;
    }
}

.chevron-container{
    flex-grow: 1;
    height: 100%;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
}

.close {
    margin-top: 10px;
    opacity: .2;
    color: white;
    font-size: 40px;
    &:hover {
        opacity: .8;
    }
    @media screen and (max-width: $break-sm) {
        font-size: 30px;
    }
}

.close-container {
    width: 98%;
    position: absolute;
    display: flex;
    justify-content: flex-end;
    height: 100%;
    align-items: end;
}

.container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-mask {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1040;
    display: flex;
    position: fixed;
    overflow-y: auto;
    user-select: none;
    overflow-x: hidden;
    flex-direction: column;
    justify-content: center;
    text-align: -webkit-center;
    -webkit-overflow-scrolling: touch;
    background-color: rgba(0, 0, 0, .97);
}

</style>
